import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Alert, Spinner, Row, Col } from 'react-bootstrap';
import api from '../api';

// Richiesta fattura da un messaggio IBS: controlla i dati fiscali (proposti leggendo il messaggio del cliente),
// emette la fattura elettronica con Fattura24 e risponde al cliente nella conversazione.
export default function FatturaDaMessaggioModal({ show, onHide, ordineId, threadId, onDone }) {
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);
  const [info, setInfo] = useState(null);
  const [dati, setDati] = useState({ codice_fiscale: '', partita_iva: '', codice_destinatario: '', pec: '' });
  const [messaggio, setMessaggio] = useState('');

  useEffect(() => {
    if (!show || !ordineId) return;
    setLoading(true);
    setError(null);
    api.get(`/mirakl/richieste-fattura/anteprima/${ordineId}`)
      .then(res => {
        const d = res.data;
        setInfo(d);
        const pick = (k) => d.dati_fiscali[k] || d.dati_proposti[k] || '';
        setDati({ codice_fiscale: pick('codice_fiscale'), partita_iva: pick('partita_iva'), codice_destinatario: pick('codice_destinatario'), pec: pick('pec') });
        setMessaggio(d.messaggio);
      })
      .catch(e => setError(e.response?.data?.detail || 'Impossibile caricare i dati dell\'ordine.'))
      .finally(() => setLoading(false));
  }, [show, ordineId]);

  const letto = (k) => !info?.dati_fiscali[k] && !!info?.dati_proposti[k]; // proposto dal messaggio, non ancora in anagrafica

  const invia = async () => {
    setSending(true);
    setError(null);
    try {
      const res = await api.post('/mirakl/richieste-fattura/emetti', { ordine_id: ordineId, thread_id: threadId, messaggio, ...dati });
      onDone && onDone(res.data);
      onHide();
    } catch (e) {
      const d = e.response?.data?.detail;
      setError(typeof d === 'string' ? d : 'Operazione non riuscita.');
    } finally {
      setSending(false);
    }
  };

  const soloMessaggio = info?.fattura_inviata;
  const mancanoDati = !soloMessaggio && !dati.codice_fiscale.trim() && !dati.partita_iva.trim();

  const campo = (k, label, placeholder) => (
    <Col md={6} className="mb-2">
      <Form.Label className="small mb-1">{label} {letto(k) && <span className="text-success">(letto dal messaggio del cliente)</span>}</Form.Label>
      <Form.Control size="sm" value={dati[k]} placeholder={placeholder} onChange={(e) => setDati({ ...dati, [k]: e.target.value })} />
    </Col>
  );

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton><Modal.Title className="fs-5">Richiesta fattura</Modal.Title></Modal.Header>
      <Modal.Body>
        {loading ? <div className="text-center"><Spinner animation="border" /></div> : info && (
          <>
            <div className="mb-3 small">
              Ordine <strong>{info.mirakl_order_id || info.ordine_id}</strong> — {info.cliente || 'cliente'} —{' '}
              {info.importo_ordine != null ? Number(info.importo_ordine).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) : ''}
            </div>
            {soloMessaggio ? (
              <Alert variant="info">
                La fattura{info.fattura_numero ? ` n. ${info.fattura_numero}` : ''} è già stata emessa (stato SDI: {info.fattura_sdi_stato}).
                Non verrà creata di nuovo: si invia solo il messaggio al cliente.
              </Alert>
            ) : (
              <>
                {info.ha_ricevuta && <Alert variant="warning" className="py-2 small">Esiste una ricevuta per questo ordine: verrà annullata (con storno dei corrispettivi) e sostituita dalla fattura.</Alert>}
                <Row>
                  {campo('codice_fiscale', 'Codice fiscale', 'es. RSSMRA85M01H501Z')}
                  {campo('partita_iva', 'Partita IVA (se azienda)', '11 cifre')}
                  {campo('codice_destinatario', 'Codice destinatario SDI (opzionale)', '7 caratteri')}
                  {campo('pec', 'PEC (opzionale)', '')}
                </Row>
                <div className="text-muted small mb-3">Verifica i dati: una volta inviata, la fattura va al Sistema di Interscambio e non si richiama.</div>
              </>
            )}
            <Form.Label className="small mb-1">Messaggio al cliente</Form.Label>
            <Form.Control as="textarea" rows={6} value={messaggio} onChange={(e) => setMessaggio(e.target.value)} />
          </>
        )}
        {error && <Alert variant="danger" className="mt-3 mb-0">{error}</Alert>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onHide} disabled={sending}>Annulla</Button>
        <Button variant="primary" onClick={invia} disabled={loading || sending || !info || mancanoDati || !messaggio.trim()}>
          {sending ? <Spinner as="span" animation="border" size="sm" /> : soloMessaggio ? 'Invia messaggio al cliente' : 'Emetti fattura e invia messaggio'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
